import React, { Component } from "react";
import { string, array, number, object, bool } from "prop-types";
import moment from "moment/moment";

import { Spinner } from "../../components";

import { Chart } from "./chart";

import "./reportChart.css";

class ReportChart extends Component {
  static propTypes = {
    aggLevel: string,
    chartWidth: number,
    chartHeight: number,
    data: array,
    startDt: string,
    endDt: string,
    timeAggregation: string,
    variable: object,
    service: object,
    loading: bool.isRequired
  };

  render() {
    const {
      aggLevel,
      chartWidth,
      chartHeight,
      data,
      variable,
      service,
      loading
    } = this.props;
    let series = [];
    if (variable && service && variable.value && service.value) {
      data.forEach(d => {
        let seriesData = [];
        if (d.data) {
          Object.keys(d.data).forEach(dt => {
            seriesData.push([
              moment.utc(dt.toString(), "YYYY-MM-DDTHH:mm:ss").unix() * 1000,
              d.data[dt][`${variable.value}_${service.value.toLowerCase()}`]
            ]);
          });
        }
        series.push({
          name: d.text,
          data: seriesData,
          showInNavigator: true,
          tooltip: {
            valueDecimals: variable.decimalPlaces
          }
        });
      });
    }

    return (
      <div className="cp-report-chart" style={{ position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              zIndex: 10,
              width: "100%",
              height: "100%",
              background: "#ffffffd4"
            }}
          >
            <Spinner
              style={{ position: "absolute", top: "49%", left: "49%" }}
            />
          </div>
        )}
        <Chart
          chartHeight={chartHeight}
          chartWidth={chartWidth}
          chartTitle={`${service && service.text} - ${variable &&
            variable.text} ${aggLevel && "by " + aggLevel}`}
          // removed dt as it is not correct representationchartSubTitle={`Data shown from ${moment(startDt).format('DD/MM/YYYY HH:mm')} - ${moment(endDt).format('DD/MM/YYYY HH:mm')} aggregated by ${timeAggregation}`}
          series={series}
          yAxisLabel={`${service && service.text} - ${variable &&
            variable.text} (${variable && variable.units})`}
          xAxisLabel="Settlement date"
        />
      </div>
    );
  }
}

export default ReportChart;



// WEBPACK FOOTER //
// ./src/views/reports/report_chart/ReportChart.jsx